var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50590_29807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0592 0.455244C10.6666 0.255521 10.1864 0.412013 9.9867 0.804759L4.05458 12.4724C3.85491 12.8651 4.0114 13.3452 4.40409 13.5448C4.5199 13.6037 4.64332 13.6316 4.76493 13.6316C5.05558 13.6316 5.33576 13.4722 5.47656 13.1953L11.4087 1.52772C11.6084 1.13502 11.4519 0.654913 11.0592 0.455244Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80007 4.29749C6.80007 2.62946 5.44301 1.2724 3.77498 1.2724C2.10706 1.2724 0.75 2.62946 0.75 4.29749C0.75 5.96546 2.10706 7.32252 3.77503 7.32252C5.44306 7.32252 6.80007 5.96546 6.80007 4.29749ZM3.77503 5.72729C2.98667 5.72729 2.34523 5.08585 2.34523 4.29749C2.34523 3.50907 2.98667 2.86763 3.77503 2.86763C4.56345 2.86763 5.20489 3.50902 5.20489 4.29749C5.20484 5.08585 4.56345 5.72729 3.77503 5.72729Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7253 6.67773C10.0573 6.67773 8.7002 8.0348 8.7002 9.70277C8.7002 11.3707 10.0572 12.7278 11.7253 12.7278C13.3933 12.7278 14.7503 11.3708 14.7503 9.70277C14.7503 8.03474 13.3933 6.67773 11.7253 6.67773ZM11.7253 11.1325C10.9369 11.1325 10.2954 10.4911 10.2954 9.70271C10.2954 8.91435 10.9369 8.27291 11.7253 8.27291C12.5136 8.27291 13.1551 8.91435 13.1551 9.70271C13.1551 10.4911 12.5137 11.1325 11.7253 11.1325Z",
    fill: "#current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50590_29807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/Percentage.aa9ac9434d5b89f0932f4eea1aa36991.svg";
export { ForwardRef as ReactComponent };